module.exports = __webpack_public_path__ + "img/album_7_m.8be48fe1.jpg";